import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as LucideIcons from "lucide-react";
import { CATEGORIES } from "../constants";
import { categoriesAPI } from "../lib/api";

export default function Categories() {
  const [cats, setCats] = useState(CATEGORIES);

  useEffect(() => {
    categoriesAPI.list().then((list) => {
      setCats(CATEGORIES.map(c => {
        const found = list.find(x => x.id === c.id);
        return { ...c, count: found?.count || 0 };
      }));
    }).catch(() => {});
  }, []);

  return (
    <div className="max-w-5xl mx-auto px-4 py-6 md:py-10" data-testid="categories-index">
      <div className="mb-5">
        <h1 className="text-2xl md:text-3xl font-black text-[#1d3d3a]">Tutte le categorie</h1>
        <p className="text-sm text-slate-600 mt-1">Trova quello che cerchi su SAN MARINO MARKET</p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
        {cats.map((c) => {
          const Icon = LucideIcons[c.icon] || LucideIcons.Box;
          return (
            <Link
              key={c.id}
              to={`/categoria/${c.id}`}
              className="bg-white rounded-2xl border border-slate-200 p-4 hover:border-[#e86a24] hover:shadow-md transition-all group"
              data-testid={`cat-card-${c.id}`}
            >
              <div className={`w-12 h-12 rounded-xl ${c.color} flex items-center justify-center mb-3 group-hover:scale-110 transition-transform`}>
                <Icon className="w-6 h-6" strokeWidth={2} />
              </div>
              <div className="font-black text-[#1d3d3a] text-sm leading-tight">{c.name}</div>
              <div className="text-xs text-slate-500 mt-1">
                {c.count > 0 ? `${c.count} annunc${c.count === 1 ? "io" : "i"}` : "Nessun annuncio"}
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
